<template>
  <div color="#F0F2F5" class="new-pay">
    <div class="top">
      <!-- <div class="back" @click="$router.go(-2)">返回</div> -->
      <div class="title">支付中心</div>
      <div></div>
    </div>
    <div class="pay-content">
      <div class="logoBox">
        <img src="@/assets/img/wj/支付页@2x.png" alt/>
      </div>
      <div class="cardBox">
        <el-form label-width="180px" label-position="right" v-model="formData">
          <el-form-item :label="moneyText">
            <span class="__money">
              {{formData.amount}}
               <span style="vertical-align:middle;display: inline-block; font-size: 16px;color: #000">元</span>
            </span>
            <!--           &lt;!&ndash;&ndash;&gt;-->
          </el-form-item>
          <el-form-item label="交易流水号">{{formData.orderNo}}</el-form-item>
          <el-form-item :label="returnType">
            <el-radio v-model="radio" label="1" border>
              账户余额
              <span>(余额:￥{{ formData.balance }})</span>
            </el-radio>
          </el-form-item>
        </el-form>
      </div>
      <div class="btnBox">
        <el-button type="primary" v-if="!isReturn" @click="onClickFu">支付</el-button>
        <el-button type="primary" v-else @click="onClickFu">退款</el-button>
        <el-button type="primary" :disabled="!formData.manager" @click="onClickPay" v-if="formData.showCharge">充值
        </el-button>
        <div style="margin-top: 5px;" v-if="formData.showCharge && !formData.manager">（请联系管理员充值）</div>
      </div>
    </div>

    <el-dialog v-if="ewmIco" :visible.sync="centerDialogVisible" :before-close="handleClose" width="35%" center>
      <div class="dialogBox">
        <div style="text-align: center">
          <img style="width:150px;height:150px" :src="'data:image/png;base64,'+ewmIco"/>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { bjRewardList, czResult } from '@/api/wenjuan/publishQuestion'
  import { getCharge, getYuE, pay } from '@/api/wenjuan/reward'
  import { mapGetters } from 'vuex'
  import { settleJob, settlementTask } from '@/api/wenjuan/offline'

  export default {
    props: {},
    components: {},
    data() {
      return {
        radio: '1',
        formData: {
          amount: 0,
          charge: 0,
          balance: 0,
          orderNo: '',
          showCharge: false
        },
        flag: true,
        centerDialogVisible: false,
        ewmIco: '',
        czId: '',
        timers: null,
        isReturn: false,
        execution: false,
        job: false
      }
    },
    computed: {
      isShowEWM() {
        return !!this.ewmIco
      },
      moneyText() {
        if (this.isReturn) {
          return '退款金额'
        }
        return '支付金额'
      },
      returnType() {
        if (this.isReturn) {
          return '退款方式'
        }
        return '支付方式'
      },
      ...mapGetters(['awardInfo'])
    },
    methods: {
      handleClose(d) {
        this.flag = false
        d()
      },
      onClickFu() {
        let surveyId = this.$route.query.id
        // let awardType = "1"
        let {
          orderNo,
          balance, charge,
          shareAward, unitAward,
          quantity, awardName, operation, awardId, max, needPay, awardType
        } = this.formData
        if (typeof operation === 'undefined') {
          awardId = max = needPay = undefined
        }
        if (charge > balance && !this.isReturn) {
          this.$message.error('余额不足请先充值')
          return
        }
        let data
        if (this.execution) {
          let { orderNo, executionBy, amount, executionId } = this.awardInfo
          if (!executionId) {
            executionId = this.formData.executionId
          }
          if (amount > balance) {
            this.$message.error('余额不足请先充值')
            return
          }
          data = { orderNo, executionBy, amount, orderSource: 2, executionId }
        } else if (this.job) {
          if (amount > balance) {
            this.$message.error('余额不足请先充值')
            return
          }
          let { orderNo, jobId, amount, effectiveQuantity, executionId } = this.awardInfo
          data = { orderNo, jobCode: jobId, orderSource: 1, amount, effectiveQuantity, executionId }
        } else {
          data = {
            surveyId,
            awardType,
            shareAward,
            unitAward,
            quantity,
            awardName,
            orderNo,
            operation,
            awardId,
            max,
            needPay,
            orderSource: 0
          }
        }
        if (this.job) {
          // settleJob({
          //   id: data.executionId,
          //   incomeAmount: data.amount
          // }).then(res => {
          pay(data).then(res => {
            if(res.data.code!=0) {
              this.$message.error(res.data.msg)
              return;
            }
            let text = this.isReturn ? '退款成功' : '支付成功'
            this.$message.success(text)
            settleJob({
              id: data.executionId,
              incomeAmount: data.amount
            }).then(res => {
              if(res.data.code!=0) {
                this.$message.error(res.data.msg)
                return;
              }
              //this.$router.go(-2)
              this.$emit('cancel')
            })
          })
          // })
        } else if (!this.execution) {
          let info = this.awardInfo
          // bjRewardList({
          //   id: info.awardId,
          //   awardName: info.awardName,
          //   unitAward: info.unitAward,
          //   awardQuantity: info.quantity,
          //   // amount: info.needPay,
          //   unitShare: info.shareAward,
          //   awardType: info.awardType,
          // }).then(res => {
          pay(data).then(res => {
            if(res.data.code!=0) {
              this.$message.error(res.data.msg)
              return;
            }
            let text = this.isReturn ? '退款成功' : '支付成功'
            this.$message.success(text)
            this.$emit('cancel')
          })
          // })
        } else {
          let id = data.executionId
          // delete data.executionId
          pay(data).then(res => {
            if(res.data.code!=0) {
              this.$message.error(res.data.msg)
              return;
            }
            let text = this.isReturn ? '退款成功' : '支付成功'
            this.$message.success(text)
            // let path
            // if (this.execution) {
            //   path = '/wenjuan/offline/index'
            // } else {
            //   path = '/wenjuan/publishQuestion/quota/rewardList?id='
            // }
            settlementTask({ id }).then(res => {
              if(res.data.code!=0) {
                this.$message.error(res.data.msg)
                return;
              }
              //this.$router.go(-2)
              this.$emit('cancel')
            })
          })
        }

      },
      onClickPay() {
        this.centerDialogVisible = true
        this.flag = true
        const msgOkArr = ['成功']
        const msgErrArr = ['转入退款', '已关闭', '已撤销', '支付失败']
        const msgMap = []
        msgOkArr.forEach(msg => {
          msgMap.push({
            type: 'success',
            msg
          })
        })
        msgErrArr.forEach(msg => {
          msgMap.push({
            type: 'error',
            msg
          })
        })
        const result = () => {
          if (this.flag) {
            czResult({ innerId: this.czId, surveyId: this.$route.query.id }).then(res => {
              // 确保上一次请求完成 再次请求
              let msg = res.data.data.chargeResult
              let findObj = msgMap.find(item => item.msg === msg)
              if (findObj) {
                this.$message[findObj.type](msg)
                // this._getYuE()
                // this.formData.balance = res.data.data.balance
                // this.formData.__ob__.dep.notify()
                this.centerDialogVisible = false
                this.flag = false
                return Promise.resolve(this.formData.balance)
              }
              setTimeout(() => {
                result()
              }, 2000)
              return Promise.reject('error')
            }).then(num => {
              const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              })
              let f = true
              const fn = () => {
                if (!f) return
                getYuE().then(res => {
                  if (num == res.data.data) {
                    fn()
                  } else {
                    loading.close()
                    this.formData.balance = res.data.data
                    this.formData.showCharge = false
                    this.formData.__ob__.dep.notify()
                  }
                })
              }
              fn()
              setTimeout(() => {
                f = false
              }, 1000 * 100)
            })
          }
        }
        this.timers = setTimeout(() => {
          if (!this.flag) return
          this.$message.error('充值失败！')
          this.flag = false
          this.centerDialogVisible = false
        }, 1000 * 120)
        result()
      },
      _getYuE() {
        getYuE().then(res => {
          this.formData.balance = res.data.data
          this.formData.__ob__.dep.notify()
        })
      }
    },
    created() {
      // this.formData = (this.$route.query.info)
      this.formData = this.awardInfo
      let { orderNo, charge, needPay, balance, isReturn, amount, executionBy, jobId, isOffline } = this.formData
      this.isReturn = isReturn
      if (!balance) {
        this._getYuE()
      }
      if (needPay) {
        this.formData.charge = needPay
        this.formData.amount = needPay
        this.formData.showCharge = balance < needPay
        this.formData.__ob__.dep.notify()
        charge = needPay
      }
      if (isOffline) {
        this.execution = true
        this.formData.charge = amount
        this.formData.amount = amount
        this.formData.showCharge = balance < amount
        charge = amount
      }
      if (jobId) {
        this.job = true
      }
      if (!charge) return
      if (isReturn) return
      let load = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      getCharge({ orderNo, charge }).then(res => {
        let d = res.data.data
        this.czId = d.innerId
        this.ewmIco = d.qrcode
        load.close()
      }).catch(err => {
        load.close()
      })
    },
    mounted() {
    },
    destroyed() {
      clearTimeout(this.timer)
      this.flag = false
    }
  }
</script>
<style scoped lang="scss">
  .new-pay {
    margin-top: 10px;
    height: 100%;

    ::v-deep .el-card__body {
      width: 100%;
      padding: 0;
    }

    .top {
      width: 100%;
      height: 60px;
      background-color: #fff;
      display: flex;
      padding-left: 20px;
      justify-content: space-between;
      line-height: 60px;

      .back {
        cursor: pointer;
      }
    }

    .pay-content {
      .logoBox {
        width: 184px;
        height: 132px;
        margin: 0 auto;

        img {
          padding: 15px 30px;
          width: 100%;
          height: 100%;
        }
      }

      .__money {
        font-size: 30px;
        color: red;
        display: inline-block;
        margin: 0 20px;
      }

      .cardBox {
        margin: 21px auto 0;
        width: 580px;
        height: 216px;
        padding: 20px;
        background: rgba(216, 232, 255, 0.22);
        border: 1px solid rgba(220, 223, 230, 1);
      }

      .btnBox {
        height: 155px;
        margin-top: 20px;
        text-align: center;
        position: relative;

        .sheng {
          width: 180px;
          height: 17px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(248, 68, 68, 1);
          line-height: 17px;
          position: absolute;
          left: 42%;
        }
      }
    }
  }
</style>

